import React from "react";

import {
  SkipLink,
  SkipLinksContainer,
} from "./skip-links.styles";

export const SkipLinks = () => {
  return (
    <SkipLinksContainer>

      <SkipLink href="#content">
        Ir para o conteúdo principal
      </SkipLink>

      <SkipLink href="#menu">
        Ir para o menu principal
      </SkipLink>

      <SkipLink href="#search">
        Ir para a busca
      </SkipLink>

      <SkipLink href="#footer">
        Ir para o rodapé
      </SkipLink>

    </SkipLinksContainer>
  );
};